
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sunpoint/studio/[...slug]",
      function () {
        return require("private-next-pages/sunpoint/studio/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sunpoint/studio/[...slug]"])
      });
    }
  